import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-signal',
  templateUrl: './status-signal.component.html',
  styleUrls: ['./status-signal.component.scss'],
})
export class StatusSignalComponent {
  @Input() active: boolean;
  @Input() label: string;
  @Input() tooltip: string;
}
